import React from "react";
import {
  DateInput,
  RadioInput,
  TextInput,
} from "../../../components/input_hook_form";
import "./style.scss";

const ratingOptions = [
  { value: "", label: "Not rated" },
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

function Morningstar(props) {
  const { register, show, control, defaultValues, setValue } = props;

  return (
    <div className={show ? "morningstar-container" : "morningstar-container-hide"}>
      <p className={"morningstar-note"}>
        These values come from the Portal NAV sync and cannot be edited here.
      </p>
      <div className={"morningstar-spacer"} />
      <RadioInput
        label={"Rating"}
        name="morningstar-rating"
        options={ratingOptions}
        control={control}
        disabled
      />
      <p className={"morningstar-note"}>
        The app shows 4 and 5 star ratings only.
      </p>
      <div className={"morningstar-spacer"} />
      <TextInput
        label={"Category"}
        placeholder={"Category"}
        register={register}
        type={"text"}
        name="morningstar-category"
        disabled
      />
      <div className={"morningstar-spacer"} />
      <DateInput
        label={"Rating Date (DD-MM-YYYY)"}
        placeholder={"Rating Date (DD-MM-YYYY)"}
        control={control}
        setValue={setValue}
        name="morningstar-ratingdate"
        disabled
        defaultValues={defaultValues["morningstar-ratingdate"]}
      />
    </div>
  );
}

export default Morningstar;
